import { Component, OnDestroy, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-map-view-expandable-table',
  templateUrl: './map-view-expandable-table.component.html',
  styleUrls: ['./map-view-expandable-table.component.scss'],
})
export class MapViewExpandableTableComponent implements OnInit, OnDestroy {
  @Input() header = [];
  @Input() tableData = [];

  public tableHeader: any[];

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.tableHeader = this.header?.filter((item) => !item.includes('Q')).map((el) => ({ field: el, header: el, isExpanded: false }));
    this.tableData.length == 0 ? (this.tableHeader = []) : '';
  }

  ngOnDestroy(): void {}

  onChangeYearExpand(column) {
    if (column.isExpanded) {
      this.tableHeader = this.header.filter((item) => !item.includes('Q')).map((el) => ({ field: el, header: el, isExpanded: false }));
    } else {
      this.tableHeader = this.header
        .filter((item) => item.includes(column.field) || !item.includes('Q'))
        .map((el) => ({ field: el, header: el.replace('_', ' '), isExpanded: el === column.field ? true : false }));
    }
  }
}
